import { PcbNodeTypes } from "@buildwithflux/models";
import { pickBy, values } from "lodash";
import { getNodesOfType } from "../../../../nodes";
import { PcbTracingGraph } from "../../../../tracing_graph";
/**
 * Creates and returns a new instance of `PcbTracingGraph` from current PCB layout node map.
 */
export function createTraceGraph(treeManager) {
    const tracingGraph = new PcbTracingGraph();
    const pcbLayoutNodes = pickBy(treeManager.treeNodes, (node) => "flattenedRules" in node && "bakedRules" in node);
    const netNodes = getNodesOfType(pcbLayoutNodes, PcbNodeTypes.net);
    const netMap = Object.fromEntries(netNodes.map((node) => [node.uid, node.terminals ?? {}]));
    const add = values(pcbLayoutNodes).map((node) => node.uid);
    tracingGraph.updateGraph({
        netMap,
        pcbLayoutNodes,
        bakedNodesChanges: {
            add,
        },
    });
    return tracingGraph;
}
//# sourceMappingURL=createTraceGraph.js.map